import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import es from './locales/es.json';
import zh from './locales/zh.json';
import srLatn from './locales/srLatn.json';
import sr from './locales/sr.json';
import hi from './locales/hi.json';
import ar from './locales/ar.json';
import pt from './locales/pt.json';
import ru from './locales/ru.json';
import ro from './locales/ro.json';
import bn from './locales/bn.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import ja from './locales/ja.json';
import ur from './locales/ur.json';
import it from './locales/it.json';
import hu from './locales/hu.json';
import el from './locales/el.json';
import tr from './locales/tr.json';


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    resources: {
      en: { translation: en },
      es: { translation: es },
      'srLatn': { translation: srLatn },
      zh: { translation: zh },
      sr:{ translation: sr },
      hi:{ translation: hi },
      ar:{ translation: ar },
      pt:{ translation: pt },
      ru:{ translation: ru },
      ro:{ translation: ro },
      bn:{ translation: bn },
      fr:{ translation: fr },
      de:{ translation: de },
      ja:{ translation: ja },
      ur:{ translation: ur },
      it:{ translation: it },
      hu:{ translation: hu },
      el:{ translation: el },
      tr:{ translation: tr }
    },
    interpolation: {
      escapeValue: false
    },
    detection: {
        order: ['localStorage', 'navigator', 'htmlTag'],
        caches: ['localStorage']
      },
  });

export default i18n;